import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { Box } from '@mui/material';

import {
  Typography,
  LoadingOverlay,
  makeZodValidate as makeValidate,
} from '@occc-app/design-system';
import { FormLayout } from '@occc-app/routes/CampaignComponents/components/FormLayout';
import { CanEditFormFields } from '@occc-app/App/CanEditFormFieldsContext';

import {
  MessagingCampaignScheduleFormProps,
  MessagingCampaignScheduleFormValues,
} from './schedule-form.types';
import { ScheduleFormSchema } from './schedule-form.schema';

import { FooterActions } from '../footer-actions/footer-actions.component';
import { MessagingCampaignTabs } from '../../messaging-campaign-configure.constants';
import { ScheduleDatePicker } from '../schedule-date-picker/schedule-date-picker.component';

export const ScheduleForm = ({
  initialValues,
  onSubmit,
  onNextStepClick,
  onCancelClick,
  loading,
  isUserPermittedToEdit,
}: MessagingCampaignScheduleFormProps) => {
  const validate = makeValidate(ScheduleFormSchema);
  const renderForm: FormRenderProps<MessagingCampaignScheduleFormValues>['render'] =
    React.useCallback(
      ({
        handleSubmit,
        submitting,
        dirty,
      }: FormRenderProps<MessagingCampaignScheduleFormValues>) => {
        const handleCancelClick = () => {
          onCancelClick(dirty);
        };

        const actions = (
          <FooterActions
            onNextStepClick={onNextStepClick}
            onCancel={handleCancelClick}
            isSubmitDisabled={submitting}
            currentTab={MessagingCampaignTabs.Schedule}
            isUserPermittedToEdit={isUserPermittedToEdit}
          />
        );

        return (
          <form onSubmit={handleSubmit} data-testid='schedule-form'>
            <FormLayout actions={actions}>
              <Box p={3}>
                <Typography variant='h6' paragraph>
                  Schedule Message
                </Typography>
                <CanEditFormFields isEditable={isUserPermittedToEdit}>
                  <ScheduleDatePicker />
                </CanEditFormFields>
              </Box>
            </FormLayout>
          </form>
        );
      },
      [isUserPermittedToEdit, onCancelClick, onNextStepClick],
    );

  return (
    <Box position='relative'>
      <CanEditFormFields isEditable={isUserPermittedToEdit}>
        <Form<MessagingCampaignScheduleFormValues>
          initialValues={initialValues}
          onSubmit={onSubmit}
          render={renderForm}
          validate={validate}
        />
      </CanEditFormFields>
      {loading && <LoadingOverlay />}
    </Box>
  );
};
